import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/Domain/components/Shared/Card/Card';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';
import { useManageSubscription } from '@/Domain/hooks/Subscription/useManageSubscription.hook';

type Props = {
  isFreeAccount: boolean;
  isPaymentFailed: boolean;
};

export const BillingPortalCard = ({ isFreeAccount, isPaymentFailed }: Props) => {
  const { t } = useTranslation('subscription_page');
  const { handleManage, isPending } = useManageSubscription();

  return (
    <TooltipProvider>
      <Tooltip open={isFreeAccount ? undefined : false}>
        <Card>
          <CardHeader>
            <CardTitle>{t('billing_portal.title')}</CardTitle>
            <CardDescription>{t('billing_portal.description')}</CardDescription>
          </CardHeader>
          <CardContent />
          <CardFooter className="mt-auto">
            <TooltipTrigger asChild>
              <Button
                variant={isPaymentFailed ? 'danger' : 'primary_dark_light'}
                onClick={handleManage}
                disabled={isPending || isFreeAccount}
              >
                {t('button.manage_billing')}
              </Button>
            </TooltipTrigger>
            <TooltipContent>{t('tooltip.manage_billing')}</TooltipContent>
          </CardFooter>
        </Card>
      </Tooltip>
    </TooltipProvider>
  );
};
